import _ from 'lodash';
import CalculatorMultipleSelectInput from '../../../../calculatorInputs/CalculatorMultipleSelectInput';
import i18next from 'i18next';
import CalculatorMultipleValueInput from '../../../../calculatorInputs/CalculatorMultipleValueInput';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const EqualValue = ({ fieldName, availableValueOptions, showLabel, readOnly = false }) => {
  const { setError, clearErrors } = useFormContext();
  const label = showLabel
    ? i18next.t('calculator.dialog.create.label.values')
    : '';
  const placeholder = i18next.t(
    'calculator.dialog.create.placeholder.selectValues'
  );

  const validate = (value) => {
    if (!Array.isArray(value) || value.length === 0) {
      setError(fieldName, {
        type: 'manual',
        message: i18next.t('calculator.errors.criterionValueEmpty'),
      });
      return false;
    }
    clearErrors(fieldName);
    return true;
  };

  const commonProps = {
    fieldName,
    isRequired: true,
    label,
    placeholder,
    uxVariant: 'criteriaInput',
    validate,
  };
  return !_.isEmpty(availableValueOptions) ? (
    <CalculatorMultipleSelectInput
      {...commonProps}
      options={availableValueOptions}
      variant="standard"
      triggerOnContinue
      disabled={readOnly}
    />
  ) : (
    <CalculatorMultipleValueInput {...commonProps} triggerOnContinue disabled={readOnly}/>
  );
};

export default EqualValue;
